module.exports = __webpack_public_path__ + "static/media/verticalIcon.d9c6dd49.svg";